var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg28TickMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.848633,
    y: 0.114258,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#26B89A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6648 12.3213C22.9187 12.588 22.9083 13.0099 22.6416 13.2638L14.9379 20.5971C14.8064 20.7224 14.6294 20.7885 14.448 20.7802C14.2665 20.772 14.0963 20.69 13.9767 20.5534L11.0137 17.1688C10.7712 16.8917 10.7992 16.4706 11.0762 16.228C11.3532 15.9855 11.7744 16.0135 12.0169 16.2905L14.5221 19.1522L21.7223 12.2981C21.989 12.0442 22.411 12.0546 22.6648 12.3213Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg28TickMark);
export default __webpack_public_path__ + "static/media/28_tick-mark.66cd696f067f09b2d7d67535f5fdb225.svg";
export { ForwardRef as ReactComponent };